import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const DateHeaderContainer = styled.span<{ $isToday: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ $isToday, theme }) =>
    $isToday &&
    css`
      color: ${theme.palette.text.primary};
    `};
`;

export const CalendarDay = styled.span<{ $isToday: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: inline-block;

  border-radius: ${({ theme }) => theme.spacing(1)};

  line-height: 1.6rem;
  text-align: center;

  ${({ $isToday, theme }) =>
    $isToday &&
    css`
      ${typographyToCss(theme.typography.buttonSmall)};
      padding: ${({ theme }) => `0 ${theme.spacing(1.5)}`};
      background: ${({ theme }) => theme.palette.error.dark};
      color: ${({ theme }) => theme.palette.error.contrastText};
    `};
`;
